import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useBuildVars } from 'src/config';
import { useIsEnvironment } from 'src/hooks/useIsEnvironment';
import { useAccount } from '@azure/msal-react';

export default function DatadogRumProvider(props: {
  children: React.ReactElement;
}) {
  const Environment = useIsEnvironment();
  const buildvars = useBuildVars();
  const account = useAccount();
  const getEnv = () => {
    if (Environment.isBetaEnvironment) return 'Beta';
    if (Environment.isProdEnvironment) return 'Production';
  };
  useEffect(() => {
    const env = getEnv();
    if (Environment.isBetaEnvironment || Environment.isProdEnvironment) {
      const sessionReplaySampleRate = env === 'Beta' ? 0 : 100; // Session Reply: 0% for Beta, 100% for Production

      datadogRum.init({
        applicationId: buildvars.DATADOG_RUM_APPLICATION_ID,
        clientToken: buildvars.DATADOG_RUM_CLIENT_TOKEN,
        defaultPrivacyLevel: 'mask-user-input',
        env: env,
        service: 'gde-pricing.app.discountpricemgmt',
        sessionReplaySampleRate: sessionReplaySampleRate,
        sessionSampleRate: 100, //This ensures that RUM events (e.g., errors, performance metrics) are also captured for 100% of user sessions.
        site: 'us5.datadoghq.com',
      });

      datadogRum.setUser({
        email: account?.username,
        id: account?.localAccountId ?? '',
        name: account?.name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return props.children;
}
